import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import { faMinus, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Summary({
    title, subtitle, total, isLoading, compareTitle, compareTotal, balance, showComparison,
})
{
    let compareStyle = 'tw-text-primary-default';
    let icon = faMinus;
    if (balance > 0)
    {
        compareStyle = 'tw-text-green-500';
        icon = faArrowUp;
    }

    if (balance < 0)
    {
        compareStyle = 'tw-text-red-500';
        icon = faArrowDown;
    }

    return (
        <div className="tw-grid tw-grid-cols-5 summary tw-justify-between widget tw-rounded tw-gap-4 tw-py-3 tw-px-4 dark:tw-bg-neutral-900 tw-bg-neutral-900 tw-mb-6">
            <div className="max-md:tw-col-span-5 tw-col-span-3 left-section tw-flex tw-flex-col ">
                <h2 className="tw-font-title title tw-text-xl tw-font-bold tw-text-white dark:tw-text-gray-100">{title}</h2>
                <p className="subtitle tw-text-sm tw-font-bold tw-text-white dark:tw-text-gray-100">{subtitle}</p>
            </div>
            <div className="max-md:tw-col-span-5 tw-col-span-2 tw-flex tw-justify-end max-md:tw-justify-start">
                <h2 className="total tw-text-lg max-md:tw-text-left max-md:tw-text-2xl 2xl:tw-text-2xl xl:tw-text-xl tw-font-bold tw-text-white dark:tw-text-white">
                    {isLoading && <LoadingSpinner loading />}
                    {isLoading || total}
                </h2>
            </div>
            {compareTotal && showComparison
                && (
                    <div className={`tw-flex tw-col-span-5 ${compareStyle}`}>
                        <h2 className="total tw-text-sm tw-font-bold">
                            {isLoading && <LoadingSpinner loading />}
                            {isLoading || compareTotal} <FontAwesomeIcon className="tw-text-sm " icon={icon} />
                        </h2>
                    </div>
                )}
            {compareTitle && showComparison
                && (
                    <div className="tw-col-span-5 left-section tw-flex tw-flex-col ">
                        <h2 className="title tw-text-xs tw-font-bold tw-text-white dark:tw-text-gray-100"> {compareTitle}</h2>
                    </div>
                )}

        </div>
    );
}

Summary.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    total: PropTypes.string.isRequired,
    compareTitle: PropTypes.string,
    compareTotal: PropTypes.string,
    isLoading: PropTypes.bool,
    showComparison: PropTypes.bool,
    balance: PropTypes.number,
};

Summary.defaultProps = {
    isLoading: false,
    balance: 0,
    showComparison: false,
};
export default Summary;
